<div ui-view="" class="ng-scope">
	<div class="wrapper wrapper-content animated fadeIn ng-scope">
		<div class="row">
			<tig-dynamic-form [ARR_form_fields]="OBJ_detail_config.fields">
			</tig-dynamic-form>
		</div>
	</div>
</div>
